__turbopack_context__.v({
  "className": "poppins_c455264f-module__b01i2W__className",
  "variable": "poppins_c455264f-module__b01i2W__variable",
});
